import React from "react";

const Maintenance = ({ message }) => {
    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                {/* Animated Background Glow */}
                <div style={styles.glowOrb}></div>
                
                {/* Top Accent with animated shine */}
                <div style={styles.topBar}>
                    <div style={styles.shine}></div>
                </div>

                {/* Icon/Visual Element */}
                <div style={styles.iconWrapper}>
                    <svg style={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z" fill="currentColor"/>
                    </svg>
                </div>

                {/* Heading */}
                <h1 style={styles.title}>
                    We'll be back <span style={styles.soon}>Soon</span>
                </h1>

                {/* Status Badge */}
                <div style={styles.badge}>
                    <span style={styles.badgeDot}></span>
                    UNDER MAINTENANCE
                </div>

                {/* Enhanced Progress Bar */}
                <div style={styles.progressContainer}>
                    <div style={styles.progress}></div>
                    <div style={styles.progressGlow}></div>
                </div>

                {/* Message */}
                <p style={styles.text}>
                    We're currently performing scheduled maintenance to enhance your experience.
                </p>
                
                <p style={styles.textSecondary}>
                    Our team is working diligently to bring you improved features and performance.
                </p>

                {message && (
                    <div style={styles.messageBox}>
                        <p style={styles.customMessage}>{message}</p>
                    </div>
                )}

                {/* Estimated Time */}
                {/* <div style={styles.etaContainer}>
                    <svg style={styles.clockIcon} viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13h-1v6l5.2 3.1.8-1.2-4.5-2.7z" fill="currentColor"/>
                    </svg>
                    <span style={styles.etaText}>Estimated completion: 2-3 hours</span>
                </div> */}

                {/* Footer */}
                <div style={styles.footer}>
                    <div style={styles.divider}></div>
                    <p style={styles.team}>Team SR PAY</p>
                    <p style={styles.company}>SR PAY Private Limited</p>
                    {/* <div style={styles.socialLinks}>
                        <span style={styles.socialIcon}>📧</span>
                        <span style={styles.socialIcon}>💬</span>
                        <span style={styles.socialIcon}>🔗</span>
                    </div> */}
                </div>
            </div>

            {/* Enhanced Animations */}
            <style>
                {`
                @keyframes progressAnim {
                    0% { width: 20%; transform: translateX(-10%); }
                    50% { width: 85%; transform: translateX(0%); }
                    100% { width: 20%; transform: translateX(10%); }
                }
                
                @keyframes glowPulse {
                    0% { opacity: 0.4; transform: scale(0.8); }
                    50% { opacity: 0.8; transform: scale(1.2); }
                    100% { opacity: 0.4; transform: scale(0.8); }
                }
                
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-8px); }
                    100% { transform: translateY(0px); }
                }
                
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(200%); }
                }
                
                @keyframes badgePulse {
                    0% { opacity: 0.6; }
                    50% { opacity: 1; }
                    100% { opacity: 0.6; }
                }
                `}
            </style>
        </div>
    );
};

export default Maintenance;

const styles = {
    wrapper: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #eef2f7 100%)",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        padding: "24px",
        position: "relative",
    },

    card: {
        maxWidth: "520px",
        width: "100%",
        textAlign: "center",
        borderRadius: "32px",
        background: "#ffffff",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.02)",
        overflow: "hidden",
        paddingBottom: "32px",
        position: "relative",
        backdropFilter: "blur(0px)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },

    glowOrb: {
        position: "absolute",
        top: "-20%",
        right: "-10%",
        width: "200px",
        height: "200px",
        background: "radial-gradient(circle, rgba(255,140,0,0.08) 0%, rgba(2,166,80,0.04) 100%)",
        borderRadius: "50%",
        pointerEvents: "none",
        animation: "glowPulse 4s ease-in-out infinite",
    },

    topBar: {
        height: "4px",
        width: "100%",
        background: "linear-gradient(90deg, #FF8C00, #02A650, #FF8C00)",
        backgroundSize: "200% 100%",
        position: "relative",
        overflow: "hidden",
    },

    shine: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
        animation: "shimmer 2.5s infinite",
    },

    iconWrapper: {
        marginTop: "32px",
        marginBottom: "20px",
        display: "inline-flex",
        padding: "16px",
        background: "linear-gradient(135deg, rgba(255,140,0,0.08), rgba(2,166,80,0.08))",
        borderRadius: "60px",
        animation: "float 3s ease-in-out infinite",
    },

    icon: {
        width: "48px",
        height: "48px",
        color: "#FF8C00",
    },

    title: {
        fontSize: "32px",
        fontWeight: "700",
        background: "linear-gradient(135deg, #FF8C00 0%, #02A650 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        marginTop: "0",
        marginBottom: "12px",
        letterSpacing: "-0.02em",
    },

    soon: {
        background: "linear-gradient(135deg, #02A650 0%, #02A650 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
    },

    badge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 14px",
        background: "#f0fdf4",
        borderRadius: "40px",
        fontSize: "12px",
        fontWeight: "600",
        color: "#02A650",
        letterSpacing: "1px",
        marginBottom: "28px",
        border: "1px solid rgba(2,166,80,0.2)",
    },

    badgeDot: {
        width: "8px",
        height: "8px",
        background: "#02A650",
        borderRadius: "50%",
        animation: "badgePulse 1.5s ease-in-out infinite",
    },

    progressContainer: {
        width: "80%",
        height: "6px",
        background: "#e9ecef",
        borderRadius: "20px",
        overflow: "hidden",
        margin: "0 auto 24px",
        position: "relative",
    },

    progress: {
        width: "60%",
        height: "100%",
        background: "linear-gradient(90deg, #02A650, #FF8C00)",
        borderRadius: "20px",
        animation: "progressAnim 2s infinite ease-in-out",
        position: "relative",
        zIndex: 1,
    },

    progressGlow: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
        animation: "shimmer 1.5s infinite",
        pointerEvents: "none",
    },

    text: {
        fontSize: "15px",
        color: "#2c3e50",
        lineHeight: "1.6",
        padding: "0 28px",
        marginBottom: "12px",
        fontWeight: "500",
    },

    textSecondary: {
        fontSize: "13px",
        color: "#6c757d",
        padding: "0 28px",
        marginBottom: "20px",
        lineHeight: "1.5",
    },

    messageBox: {
        margin: "16px 28px 20px",
        padding: "14px 20px",
        background: "#fff9f0",
        borderRadius: "16px",
        borderLeft: "3px solid #FF8C00",
    },

    customMessage: {
        fontSize: "13px",
        color: "#856404",
        margin: 0,
        lineHeight: "1.5",
    },

    etaContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        marginBottom: "28px",
        padding: "8px 16px",
        background: "#f8f9fa",
        borderRadius: "40px",
        width: "fit-content",
        marginLeft: "auto",
        marginRight: "auto",
    },

    clockIcon: {
        width: "16px",
        height: "16px",
        color: "#FF8C00",
    },

    etaText: {
        fontSize: "12px",
        color: "#495057",
        fontWeight: "500",
    },

    footer: {
        marginTop: "20px",
        paddingTop: "20px",
    },

    divider: {
        width: "40px",
        height: "2px",
        background: "linear-gradient(90deg, #FF8C00, #02A650)",
        margin: "0 auto 16px",
        borderRadius: "2px",
    },

    team: {
        fontWeight: "600",
        color: "#FF8C00",
        marginBottom: "4px",
        fontSize: "14px",
    },

    company: {
        fontSize: "11px",
        color: "#adb5bd",
        letterSpacing: "0.3px",
        marginBottom: "12px",
    },

    socialLinks: {
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        marginTop: "12px",
    },

    socialIcon: {
        fontSize: "18px",
        opacity: 0.5,
        cursor: "pointer",
        transition: "opacity 0.2s ease",
    },
};